// Runtime configuration using environment variables.
// In browser bundles this reads from a server-injected window payload so a
// single built image can run in multiple environments.

const WINDOW_RUNTIME_CONFIG_KEY = '__CONTENT_APP_RUNTIME_CONFIG__';

const CLIENT_RUNTIME_PUBLIC_KEYS = [
  'applicationNamespace',
  'monetateApiURL',
  'monetateExperienceName',
  'monetateScriptUrl',
];

function buildPublicRuntimeConfig(source = {}) {
  const vendorHost = source.VENDOR_HOST;
  const ensightenEnv = source.ENSIGHTEN_ENV;
  const monetateEnvironment = source.MONETATE_ENVIRONMENT;
  const monetateScriptUrl = monetateEnvironment
    ? `//se.monetate.net/js/2/${monetateEnvironment}/entry.js`
    : undefined;
  const ensightenBootstrapUrl = ensightenEnv
    ? `/bootstrap/johnlewis/${ensightenEnv}/bootstrap.html`
    : undefined;

  return {
    host: vendorHost,
    newrelic: {
      enabled: source.NEW_RELIC_ENABLED,
      agentID: source.NEW_RELIC_AGENT_ID,
      applicationID: source.NEW_RELIC_APPLICATION_ID,
    },
    analytics: {
      enabled: source.ENSIGHTEN_ENABLED,
      bootstrapUrl: ensightenBootstrapUrl,
    },
    appEnv: source.APP_ENV,
    featuresRefreshInterval: source.FEATURES_REFRESH_INTERVAL,
    featuresAppUrl: source.FEATURES_APP_URL,
    featuresAppEnvironment: source.FEATURES_APP_ENV,
    featuresInstanceId: source.FEATURES_INSTANCE_ID,
    featureFlagName: 'Crayon feature flags',
    applicationName: source.APPLICATION_NAME || 'content-app',
    applicationVersion: source.APPLICATION_VERSION || 'unknown',
    applicationNamespace: source.APP_NAMESPACE || 'content-app',
    analyticsUrl:
      source.ANALYTICS_URL ||
      `https://${vendorHost}/static/analytics/ensighten/${ensightenEnv}/nexus-web.js`,
    newRelicEnabled: source.NEW_RELIC_ENABLED,
    newRelicAgentId: source.NEW_RELIC_AGENT_ID,
    newRelicApplicationId: source.NEW_RELIC_APPLICATION_ID,
    monetateApiURL: source.MONETATE_API_URL,
    monetateEnvironment,
    monetateScriptUrl,
    monetateExperienceName: source.MONETATE_EXPERIENCE_NAME,
  };
}

function buildServerRuntimeConfig(source = {}) {
  return {
    isDev: source.NODE_ENV === 'development',
    featuresRefreshInterval: source.FEATURES_REFRESH_INTERVAL,
    featuresAppUrl: source.FEATURES_APP_URL,
    featuresAppEnvironment: source.FEATURES_APP_ENV,
    featuresInstanceId: source.FEATURES_INSTANCE_ID,
    productCatalogueEndpoint: source.PRODUCT_CATALOGUE_ENDPOINT,
    productCatalogueApiKey: source.PRODUCT_CATALOGUE_KEY,
  };
}

function getInjectedRuntimeConfig() {
  if (typeof globalThis === 'undefined') {
    return undefined;
  }

  return globalThis[WINDOW_RUNTIME_CONFIG_KEY];
}

export const publicRuntimeConfig = buildPublicRuntimeConfig(process.env);
export const serverRuntimeConfig = buildServerRuntimeConfig(process.env);

export function buildInjectedClientConfig(config = publicRuntimeConfig) {
  const clientPublicRuntimeConfig = CLIENT_RUNTIME_PUBLIC_KEYS.reduce(
    (acc, key) => {
      if (typeof config[key] !== 'undefined') {
        acc[key] = config[key];
      }

      return acc;
    },
    {}
  );

  return {
    publicRuntimeConfig: clientPublicRuntimeConfig,
  };
}

export default function getConfig() {
  const injectedConfig = getInjectedRuntimeConfig();

  if (injectedConfig && injectedConfig.publicRuntimeConfig) {
    return {
      publicRuntimeConfig: injectedConfig.publicRuntimeConfig,
      serverRuntimeConfig,
    };
  }

  return {
    publicRuntimeConfig,
    serverRuntimeConfig,
  };
}
